import { GeoFence } from '../../domain/geoFence/GeoFence';
import { FlatProject } from '../../domain/project/FlatProject';
import { Project } from '../../domain/project/Project';
import { ProjectUser } from '../../domain/project/ProjectUser';
import { VehicleFlat } from '../../domain/vehicle/VehicleFlat';
import { ProjectActionType, ProjectActions } from './actions';

export interface ProjectState {
  flatProjects: FlatProject[];
  activeProject?: Project;
  vehicles: {
    flat: Array<VehicleFlat>;
  };
  users?: Array<ProjectUser>;
  geoFences: Array<GeoFence>;
}

export const getInitialState = (): ProjectState => ({
  flatProjects: [],
  activeProject: undefined,
  vehicles: {
    flat: [],
  },
  users: undefined,
  geoFences: [],
});

export const ProjectReducer = (state: ProjectState, action: ProjectActions): ProjectState => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECTS_SUCCESS:
      return {
        ...state,
        flatProjects: action.payload.flatProjects,
      };
    // case ProjectActionType.PROJECTS_CREATE_PROJECT_SUCCESS:
    //   return {
    //     ...state,
    //     flatProjects: [...(state.flatProjects ?? []), action.payload.project],
    //   };
    case ProjectActionType.SET_ACTIVE_PROJECT:
      return {
        ...state,
        activeProject: action.payload.activeProject,
      };
    // case ProjectActionType.PROJECTS_EDIT_PROJECTS_RESOURCES_SUCCESS:
    //   // Updates the projects resources.
    //   return {
    //     ...state,
    //     flatProjects: action.payload.projects,
    //   };
    case ProjectActionType.SEARCH_FLAT_VEHICLES_SUCCESS:
      return {
        ...state,
        vehicles: {
          flat: action.payload.flatVehicles,
        },
      };
    case ProjectActionType.FETCH_PROJECT_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.users,
      };
    case ProjectActionType.FETCH_PROJECT_GEOFENCES_SUCCESS:
      return {
        ...state,
        geoFences: action.payload.geoFences,
      };
    case ProjectActionType.RESET_PROJECT:
      return getInitialState();
    default:
      return state;
  }
};
